
import React from 'react'
// import MainProfileView from "./pages/MainProfileView"
import { Route, Routes } from 'react-router-dom'
import Outlet from './components/Outlet'
import { login, pages } from './components/sidebar/navigation'

const App = () => {
  return (
    <>
    <div>
    <Routes>
      { login.map((item)=>(
        <Route path={item.path} element={<div className='flex justify-center m-auto'>{item.component}</div>} />
      ))
      }
      <Route path="/" element={<Outlet/>}>
        {
          pages.map((item)=>(
            <Route key={item.name} path={`/${item.path}`} element={item.component}/>
            ))
          }
      </Route>
    </Routes>
    </div>
    </>
  )
}

export default App;
